import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWorkspaceUpdateAvatar extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORKSPACE_UPDATE_AVATAR;

  workspace_id!: string;
  file_data!: DTO__file_data;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
  }
}
